import { render } from "./App.vue?vue&type=template&id=094fbc82"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=094fbc82&lang=scss"

import exportComponent from "/home/runner/work/emoemoji/emoemoji/vue/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__